//Kiểu dữ liệu cột trong mẫu bảng lương
export default {
  Amount: 3,//Số tiền
  Text: 4,//Chữ
  Rate: 2,//Tỷ lệ
  Coefficient: 1,//Hệ số
};
